import React from "react";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";
import { formValueSelector, Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/inventories/actions";
import { searchUsers } from "MODULES/users/actions";
import {
  form,
  Form as AppForm,
  CurrencyField,
  Select
} from "MODULES/shared/components/Forms";
import { dollars } from "LIB/formatters/currency";
import { removeKeys } from "LIB/removeKey";
import { COST_ADJUSTMENT_OPTIONS } from "../../constants";
import validate from "./validate";
import FormRow from "../../../shared/components/Forms/FormRow";
import Warning from "../../../shared/components/Warning/Warning";

function toOptions(map, textField = "label") {
  return Object.keys(map).map(t => {
    const text = textField ? map[t][textField] : map[t];
    if (typeof text === "function") {
      return { value: t, text: text() };
    }

    return { value: t, text };
  });
}

const CostAdjustmentFields = ({
  costAdjustedTotal,
  adjustmentType,
  adjustment,
  totalCost,
  negative
}) => (
  <React.Fragment>
    <FormRow>
      <Col md={7}>
        <Field
          name="adjustment_type"
          component={Select}
          options={toOptions(
            removeKeys(COST_ADJUSTMENT_OPTIONS, [
              "neg_warranty_non_reimbursed",
              "pos_lot_cost",
              "neg_lot_cost"
            ])
          )}
          label="Adjustment Type"
          required
        />
      </Col>
      <Col md={5}>
        <CurrencyField name="adjustment" label="Cost Adjustment" required />
      </Col>
    </FormRow>
    <hr className="hr-xs hr-dashed" />
    <h5 className="h3 text-left">
      Preview: {dollars(totalCost)} {negative ? "-" : "+"}{" "}
      {dollars(adjustment || 0)} = &nbsp;
      {adjustmentType && dollars(costAdjustedTotal)}
    </h5>
  </React.Fragment>
);

CostAdjustmentFields.propTypes = {
  costAdjustedTotal: PropTypes.number,
  adjustmentType: PropTypes.string,
  adjustment: PropTypes.number,
  totalCost: PropTypes.number,
  negative: PropTypes.bool
};

export function AskIfAfterInternalOutright(props) {
  return [
    <Warning>
      Please confirm if this charge that is associated to this record should be
      applied as new cost (After Internal Outright) or as old cost (Before
      Internal Outright)
    </Warning>,
    <div className="btn-group" style={{ marginLeft: 10 }}>
      <button
        className="btn btn-default"
        type="button"
        onClick={() => {
          props.change("after_internal_outright", true);
          props.setAskedInternalOutright(true);
        }}
      >
        After Internal Outright
      </button>
      <button
        className="btn btn-primary"
        type="button"
        onClick={() => props.setAskedInternalOutright(true)}
      >
        Before Internal Outright
      </button>
    </div>
  ];
}

export function CostAdjustmentForm(props) {
  const { inventory, adjustment, adjustmentType } = props;
  const totalCost = inventory.total_cost || 0;
  const negative = adjustmentType && adjustmentType.startsWith("neg_");
  const costAdjustedTotal = negative
    ? totalCost - adjustment || 0
    : parseFloat(totalCost) + parseFloat(adjustment) || 0;

  return (
    <AppForm {...props}>
      <AppForm.Body>
        {props.askedInternalOutright ? (
          <CostAdjustmentFields
            costAdjustedTotal={costAdjustedTotal}
            adjustmentType={adjustmentType}
            adjustment={adjustment}
            totalCost={totalCost}
            negative={negative}
          />
        ) : (
          <AskIfAfterInternalOutright {...props} />
        )}
      </AppForm.Body>
      {!props.askedInternalOutright && <span />}
    </AppForm>
  );
}

CostAdjustmentForm.propTypes = {
  inventory: PropTypes.shape({}),
  adjustment: PropTypes.string,
  adjustmentType: PropTypes.string,
  askedInternalOutright: PropTypes.bool,
  setAskedInternalOutright: PropTypes.func
};

const selector = formValueSelector("addCostAdjustment");

export default connect(
  state => ({
    adjustment: selector(state, "adjustment"),
    adjustmentType: selector(state, "adjustment_type")
  }),
  dispatch => ({
    queryUsers: filter => dispatch(searchUsers(filter)),
    onSubmit: (data, _, props) =>
      dispatch(actions.addCostAdjustment(data, props))
  })
)(
  form({
    form: "addCostAdjustment",
    validate
  })(CostAdjustmentForm)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/AddCostAdjustment/CostAdjustmentForm.jsx